import { RouterOutputs, trpc } from "../trpc";

interface Input {
  folderId?: string;
}

export type FolderShare =
  RouterOutputs["folder"]["folderShares"]["results"][number];

export function useQueryFolderShares({ folderId }: Input) {
  const { data, isLoading } = trpc.folder.folderShares.useQuery(
    { folderId },
    { enabled: !!folderId },
  );
  const shares = data?.results || ([] as FolderShare[]);

  return {
    shares,
    isSharesLoading: isLoading,
  };
}
